// extracted by mini-css-extract-plugin
export default {"centerText":"Displaybyletter_centerText__m2iHT"};